var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"Input",class:{ 'placeholder-transparent': _vm.transparent },domProps:{"value":_vm.value},on:{"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }